module.exports = __webpack_public_path__ + "img/Flag_of_the_Faroe_Islands.04d0d262.svg";